import { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, EffectFlip, Navigation, Pagination } from 'swiper/modules';
import { SliderNavigation } from './navigation';
import 'swiper/css';
import 'swiper/css/effect-flip';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import s from './index.module.scss';

export const OffersDesktop = ({ data }) => {
  const [swiperRef, setSwiperRef] = useState(null);

  const onNext = () => {
    swiperRef?.slideNext();
  };

  const onPrev = () => {
    swiperRef?.slidePrev();
  };

  if (!data) return null;

  return (
    <div className={s.wrapper}>
      <Swiper
        onSwiper={setSwiperRef}
        effect={'flip'}
        loop={data?.length > 1}
        grabCursor={true}
        modules={[EffectFlip, Navigation, Pagination, Autoplay]}
        autoplay={{
          delay: 5000, // 5 seconds
          disableOnInteraction: false,
        }}
      >
        {data.map((card, index) => (
          <SwiperSlide key={index} style={{ width: '335px' }}>
            {card}
          </SwiperSlide>
        ))}
      </Swiper>
      {data.length > 1 && (
        <SliderNavigation
          className={s.navigation}
          onNext={onNext}
          onPrev={onPrev}
        />
      )}
    </div>
  );
};
